

























import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class PMenu extends Vue {
  @Prop({}) public list!: any;
  @Prop({}) public defaultActive!: string;
  private menuList: any = [];
  private active = -1;
  private hoverActive: any = null;
  private created() {
    this.active = this.list.findIndex((i: any) => i.url === this.defaultActive);
  }
  private handleAction(val: any, index: number) {
    console.log(val, "跳转");
    this.active = index;
    this.$emit("select", val.url);
  }
}
